import Vue from 'vue'
import Vuex from 'vuex'

import Global from './modules/global'
import Products from './modules/products'
import Resellers from './modules/resellers'
import Fluxes from './modules/fluxes'
import Tags from './modules/tags'
import Categories from './modules/categories'
import Pages from './modules/pages'
import Brands from './modules/brands'
import Users from './modules/users'
import Menus from './modules/menus'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Products,
    Resellers,
    Tags,
    Categories,
    Pages,
    Fluxes,
    Brands,
    Users,
    Menus
  },
  state: {},
  mutations: {},
  actions: {}
})
